export default __webpack_public_path__ + "static/1020-5d0eccce9e18014bcfd143fdbc071586.gif";